import React from "react";

const Java_Abstraction = () => {
  return (
    <div>
      <h1>Java Abstraction</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Abstraction in Java.</p>
    </div>
  );
};

export default Java_Abstraction;
